export interface IFacebookAccount {
  openId: string
  shopId: string
  objectId: string
  merchant: string
  sellerName: string
  imageUrl?: string
}

export interface IFacebookOfficialPage {
  access_token: string
  category: string
  id: string
  image: string
  name: string
}

export interface IFacebookPage {
  accessToken: string
  category: string
  pageId: string
  imageUrl: string
  pageName: string
  assigns: string[]
  objectId: string
}

export interface IFacebookChatRoom {
  objectId: string
  chatId: string
  merchant: string
  pageId: string
  userId: string
  attachments: any
  imageUrl?: string
  message: string
  name: string
  pageName: string
  tags: IFacebookChatRoomTag[]
  assignToUser: string
  readBy: string
  unReadCount: number
  assigns: string[]
  page?: IFacebookPage
  createdAt: string
  updatedAt: string

  fullName: string
  phone: string
  email: string
  address: string
  subDistrict: string
  district: string
  province: string
  zipcode: string
  note: string

  status: EFacebookChatRoomStatus
}

export interface IFacebookChatRoomTag {
  objectId?: string
  name: string
  color: string
  count?: number
}

export interface IFacebookChatRoomCount {
  assigned: { count: number; unread: number }
  total: { count: number; unread: number }
  unassign: { count: number; unread: number }
}

export enum EFacebookChatRoomStatus {
  OPEN = 'open',
  PURCHASED = 'purchased',
  HOLD = 'hold',
  CLOSED = 'closed',
}

export const FacebookChatRoomStatus = [
  { status: EFacebookChatRoomStatus.OPEN, label: 'แชทเปิด' },
  { status: EFacebookChatRoomStatus.PURCHASED, label: 'ชำระแล้ว' },
  { status: EFacebookChatRoomStatus.HOLD, label: 'ติดตาม' },
  { status: EFacebookChatRoomStatus.CLOSED, label: 'ปิดแชท' },
]
